import { baanRueJaiClient } from "@/dependencies";

export class EvUseCase {
  constructor(client) {
    this.client = client;
  }

  async getStations() {
    const { data } = await this.client.admin.ev.get();

    return data.result;
  }

  async stopAndExit(sessionId) {
    const { data } = await this.client.admin.ev.stopAndExit(sessionId);

    return data.result;
  }

}

export const evUseCase = new EvUseCase(baanRueJaiClient);
